import PowerCalendarDaysMultiple from 'ember-power-calendar/components/power-calendar-multiple/days';

export default class SchoolDatesDays extends PowerCalendarDaysMultiple {
  // Disable automatic day-click event handling, as this is handled in the template.
  handleClick() {}
}
